import { dbiBtnLogMes, dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';
import { reportButtonLog } from '@intelligence/v3/_hooks/usePageLog';

export const ROBLOX_TOP_CHARTS_PAGE_LOG_KEY = 'casualGamesHubRobloxTopCharts';
export const ROBLOX_TOP_CHARTS_DOWNLOAD_LOG_KEY = 'casualGamesHubRobloxTopChartsDownloadClick';

export const getRobloxTopChartsSearchPageLogInfo = (): {
  pageId: string;
  typeId: string;
} => {
  const pageLog = dbiPageLogMes[ROBLOX_TOP_CHARTS_PAGE_LOG_KEY];

  return {
    pageId: pageLog?.pageId || '',
    typeId: pageLog?.typeId || '',
  };
};

export const reportRobloxTopChartsDownloadLog = (): void => {
  const pageLog = dbiPageLogMes[ROBLOX_TOP_CHARTS_PAGE_LOG_KEY];
  const btnLog = dbiBtnLogMes[ROBLOX_TOP_CHARTS_DOWNLOAD_LOG_KEY];

  if (!pageLog || !btnLog) {
    return;
  }

  reportButtonLog({
    ...btnLog,
    pageId: pageLog.pageId,
  });
};
